import React, { Component, Fragment } from 'react'
import createHoverRef from './createHoverRef'
import HelpIconSvg from './HelpIconSvg'
import injectStyles from 'react-jss'

const styles = {

}

class HelpIcon extends Component {

  render = () => {
    const {
      classes,
      helpText,
      onHelpTextChange,
      // If we're currently dragging we don't want to show the help text popup
      // it would get in the way
      disabled,
      hoverContainerRef,
    } = this.props
    var HoverContainer = props => <StyledHelpTextWidget
      value={helpText}
      onChange={onHelpTextChange}
      ref={hoverContainerRef}
    />

    return <Fragment>
      <div
        ref={disabled ? null : createHoverRef(HoverContainer)}
        {...this.props}>
        <HelpIconSvg/>
      </div>
    </Fragment>
  }
}

export default injectStyles(styles)(HelpIcon)

const helpTextWidgetStyles = {
  helpBox: {
    width: 470,
    paddingLeft: 28,
    paddingRight: 28,
    paddingTop: 14,
    paddingBottom: 60,
    boxSizing: 'border-box',
    border: '1px solid #ebedf0',
    borderRadius: 2,
    backgroundColor: 'white',
    position: 'relative',
  },
  hoverHelpIcon: {
    position: 'absolute',
    left: 14,
    bottom: 14,
  },
  input: {
    resize: 'none',
    border: 'none',
    width: '100%',
    minHeight: 30, // To avoid wierd size change on first type
    boxSizing: 'border-box',
    fontSize: 13,
    margin: 0,
  },
  helpTextContainer: {
    position: 'relative',
  },
  placeholder: {
    color: 'grey',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    fontSize: 13,
  },
}

class HelpTextWidget extends Component {

  constructor(props){
    super(props)
    this.value_ = props.value || ''
  }

  onChange = (e) => {
    this.value_ = e.target.innerText
    if (this.value_){
      if (this.container_.contains(this.placeholder_))
        this.container_.removeChild(this.placeholder_)
    } else {
      this.container_.appendChild(this.placeholder_)
    }
  }

  onBlur = () => {
    this.props.onChange(this.value_)
  }

  render = () => {
    const { classes } = this.props
    return <div className={classes.helpBox}>
      <div className={classes.helpTextContainer} ref={el => this.container_ = el}>
        <p
          onInput={this.onChange}
          className={classes.input}
          ref={el => {
            if (el)
              el.innerText = this.value_
          }}
          contentEditable
          onBlur={this.onBlur}
        >
        </p>
        {!this.value_ ? <p
          className={classes.placeholder}
          ref={el => this.placeholder_ = el}
        >
          Enter your help text here...
        </p> : null}
      </div>
      <HelpIconSvg className={classes.hoverHelpIcon} />
    </div>
  }
}

const StyledHelpTextWidget = injectStyles(helpTextWidgetStyles)(HelpTextWidget)



// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/HelpIcon/HelpIcon.js